import React from 'react'
import { VersionInformationModel } from '../../../api/settings'
import remoteData, { RemoteData } from '../../../shared/remote-data'

// STATE
export type State = {
    readonly versionInformation: RemoteData<Error, VersionInformationModel>
}

export const initialState: State = {
    versionInformation: remoteData.loading(),
}

// ACTIONS
const FETCH_BUILD_VERSION_SUCCEEDED = 'FETCH_BUILD_VERSION_SUCCEEDED'
const FETCH_BUILD_VERSION_FAILED = 'FETCH_BUILD_VERSION_FAILED'

export type Action =
    | {
          readonly type: typeof FETCH_BUILD_VERSION_SUCCEEDED
          readonly payload: {
              readonly value: VersionInformationModel
          }
      }
    | {
          readonly type: typeof FETCH_BUILD_VERSION_FAILED
          readonly payload: {
              readonly error: Error
          }
      }

export const fetchBuildVersionSucceeded = (
    value: VersionInformationModel
): Action => ({
    type: FETCH_BUILD_VERSION_SUCCEEDED,
    payload: {
        value,
    },
})

export const fetchBuildVersionFailed = (error: Error): Action => ({
    type: FETCH_BUILD_VERSION_FAILED,
    payload: {
        error,
    },
})

// REDUCER

export const reducer: React.Reducer<State, Action> = (state, action) => {
    switch (action.type) {
        case FETCH_BUILD_VERSION_SUCCEEDED:
            return {
                ...state,
                versionInformation: remoteData.succeeded(action.payload.value),
            }

        case FETCH_BUILD_VERSION_FAILED:
            return {
                ...state,
                versionInformation: remoteData.failed(action.payload.error),
            }
    }
}

// CONTEXT

export type Store = {
    state: State
    dispatch: React.Dispatch<Action>
}

export const StoreContext = React.createContext<Store>({
    state: initialState,
    dispatch: () => {},
})
